import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteCropExplorationEntry, deleteCropExplorationTemplateEntry } from "services";

import { DELETE_CROP_EXPLORATION_ENTRY, GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useDeleteCropExplorationEntry = (isAdmin: boolean = false) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_CROP_EXPLORATION_ENTRY],
    mutationFn: !isAdmin ? deleteCropExplorationEntry : deleteCropExplorationTemplateEntry,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
